import moment from "moment";

/* =============================================================================
   The member's voucher list.

   ⚠⚠ The seven attributes on each button — producttype, discounttype,
   issuedvoucherid, memberid, lockedflag, showlockedmsg, lockedmsgflag — are
   NOT data-* attributes. handleSelectVoucher reads them by those exact
   lowercase names off event.currentTarget. React only passes unknown
   attributes through when they are all-lowercase, so renaming one to camelCase
   or to data-* makes it vanish from the DOM and the handler reads null.

   ⚠ showLockedMsg / lockedMsgFlag are computed by a first pass over the WHOLE
   list and then read inside the per-voucher map. They describe the list, not
   the voucher — that is why the forEach above runs separately. Folding it into
   the map changes which message the customer gets.

   ⚠ Only item + DollarFixed vouchers can be redeemed online. Everything else
   gets the "Redeem In-Store" badge, which is the only thing telling the
   customer why tapping it will not work.
   ============================================================================= */

export default function VoucherList(props) {

    // === Checks List - Determine which message to display if looking at whole voucher list ===
    let showLockedMsg = "false";
    let lockedMsgFlag;
    (props.vouchers).forEach((voucher) => {
        if (voucher.isLocked) {
            showLockedMsg = "true";
            if (props.voucherIssueIdInCart == voucher.loyaltyIssuedProductID) {
                lockedMsgFlag = "1"; // Locked Message to display for 'In Cart'
            } else {
                lockedMsgFlag = "2"; // Locked Message to display for 'Used In Another Cart'
            }
        }
    })

    let voucherList = props.vouchers.length > 0 ?
        props.vouchers.map((item) => {
            let expiryDate = item.loyaltyProductExpiryDate ? moment(item.loyaltyProductExpiryDate, 'YYYY-MM-DDTHH:mm:ss').format('DD/MM/YYYY') : '';
            let lockedBadge;
            let lockedFlag = ""; // Determines which message to display to the user if unable to redeem voucher
            let isInCart = false;
            if (item.isLocked && item.productType === 'item' && item.discountTypeString === 'DollarFixed') {
                showLockedMsg = "true"; // Checks List
                if (props.voucherIssueIdInCart == item.loyaltyIssuedProductID) {
                    lockedBadge = <span className="wo-vou__tag wo-vou__tag--on">In Cart</span>
                    lockedFlag = "1"; // Voucher Exists in Current In Cart
                    lockedMsgFlag = "1"; // Locked Message to display for 'In Cart' - Checks List
                    isInCart = true;
                } else {
                    lockedBadge = <span className="wo-vou__tag wo-vou__tag--off">Used In Another Cart</span>
                    lockedFlag = "2"; // Voucher Used In Another Cart
                    lockedMsgFlag = "2"; // Locked Message to display for 'Used In Another Cart' - Checks List
                }
            } else {
                lockedBadge = <></>
                lockedFlag = "0"; // Not Locked & Valid > Able to redeem
            }

            let redeemInStoreBadge;
            if (item.productType === 'item' && item.discountTypeString === 'DollarFixed') {
                // Currently only able to redeem:
                // - Dollar Fixed Total Vouchers
                redeemInStoreBadge = <></>
            } else {
                redeemInStoreBadge = <span className="wo-vou__tag">Redeem In-Store</span>
            }

            return (
                <button type="button"
                    key={item.loyaltyIssuedProductID}
                    className={`wo-vou${isInCart ? ' wo-vou--on' : ''}`}
                    onClick={props.handleSelectVoucher}
                    producttype={item.productType}
                    discounttype={item.discountTypeString}
                    issuedvoucherid={item.loyaltyIssuedProductID}
                    memberid={item.memberID}
                    lockedflag={lockedFlag}
                    showlockedmsg={showLockedMsg}
                    lockedmsgflag={lockedMsgFlag}
                >
                    <span className="wo-vou__name">{item.loyaltyProductNameExternal}</span>
                    {item.loyaltyProductRewardDescription &&
                        <span className="wo-vou__desc">{item.loyaltyProductRewardDescription}</span>}
                    <span className="wo-vou__tags">
                        {expiryDate && <span className="wo-vou__tag">Expires {expiryDate}</span>}
                        {redeemInStoreBadge}
                        {lockedBadge}
                    </span>
                </button>
            )
        })
        :
        <div className="wo-vou__empty">
            <p className="wo-vou__emptyHead">No rewards yet</p>
            <p className="wo-vou__emptySub">Vouchers you earn will show up here.</p>
        </div>

    return voucherList
}
